// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import { i18n } from './i18n'

Vue.use(Vuetify)
let opts = {
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  },
  /*lang: {
    t: (key, ...params) => i18n.t(key, params)
  }*/
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
}


export default new Vuetify(opts)




// WEBPACK FOOTER //
// ./src/plugins/vuetify.js